import Cookie from 'js-cookie'

import { updateCartAttributesReconcile } from '@/clients/shopify/client'
import type { Cart } from '@/types/shopify'
import { simpleCartToken } from '@/utilities/commerce'

export const initImpact = async (cart?: Cart) => {
  const searchParams = new URLSearchParams(window.location.search)
  const irclickid: string | null | undefined =
    searchParams.get('irclickid') || Cookie.get('irclickid')

  if (irclickid) {
    Cookie.set('irclickid', irclickid, { expires: 30 })
  }

  if (irclickid && cart?.id) {
    if (
      cart.attributes.find((attr) => attr.key === 'irclickid')?.value ===
      irclickid
    ) {
      return
    }

    await updateCartAttributesReconcile(cart.id, [
      ...cart.attributes,
      {
        key: 'irclickid',
        value: irclickid,
      },
      {
        key: 'customProfileId',
        value: simpleCartToken,
      },
    ])
  }
}
